import { useState, useEffect } from "react";
import "./GenerateLoader.scss";

const ReportLoader = () => {
  const [dots, setDots] = useState("");
  const [messageIndex, setMessageIndex] = useState(0);

  const messages = [
    "Analyzing your performance data",
    "Evaluating your progress across sections",
    "Identifying your strengths and areas for improvement",
    "Generating personalized recommendations",
    "Creating your detailed performance report",
  ];

  useEffect(() => {
    const dotsInterval = setInterval(() => {
      setDots((prev) => (prev.length === 3 ? "" : prev + "."));
    }, 500);

    const messageInterval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % messages.length);
    }, 5000);

    return () => {
      clearInterval(dotsInterval);
      clearInterval(messageInterval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="loader-overlay">
      <div className="loader-box">
        <div className="loader-icon">
          <div className="spinner"></div>
        </div>
        <h3 className="loader-title">Generating Your Performance Report</h3>
        <p className="loader-message">{messages[messageIndex]}{dots}</p>
        <p className="loader-subtext">This may take a few moments. Please wait...</p>
      </div>
    </div>
  );
};

export default ReportLoader;
